import { useEffect, useState } from 'react'
import Header from '../../../components/Header'
import Table from '../CartComponent/Table';
import Address from '../CartComponent/Address/Address';
import CreditSection from '../CartComponent/Credit/CreditSection';
import { gettoken, shippingidremove } from '../../../Localstorage/Store';
import { useGetCreditQuery, usePostApplyCreditMutation } from '../../../store/api/cartapi';
import Creditsummary from '../CartComponent/Credit/Creditsummary';
import axios from 'axios';

const Credit = ({ cartInfo, address, shippingCharges, popup, onAddressChange }) => {
  const tokenvalue = gettoken();
  const [showbtn, setshowbtn] = useState(false);
  const [taxable_total, settaxable_total] = useState(0);
  const [tableData, settableData] = useState([]);
  const [client_Discount_Status, setclient_Discount_Status] = useState(false)
  const [outofstock, setOutOfStock] = useState(false);
  const [gst_total, setgst_total] = useState(0);
  const [totalmrp, settotalmrp] = useState(0);
  const [totalqty, settotalqty] = useState(0);
  const [creditGst, setcreditGst] = useState(false);
  const [creditShipping, setcreditShipping] = useState(false);
  const [totalCreditAmount, settotalCreditAmount] = useState(0);
  const [credit_minus_amount, setcredit_minus_amount] = useState(0);
  const [AllowCredit, setAllowCredit] = useState(0);
  const [AppliedCreditAmount, setAppliedCreditAmount] = useState(0);

 const { data: creditData, isLoading: creditLoading } = useGetCreditQuery();
 const [appliedCredit] = usePostApplyCreditMutation();

 const creditUsed = (shipAmount,TotalAmount,gstAmount,taxableAmount,creditAmount,gst,shipping) => {

        if(creditAmount > (TotalAmount + shipAmount)){
          if(gst == true && shipping == true){
           return TotalAmount + shipAmount;
          }
          if(gst == true && shipping == false){
           return TotalAmount;
          }
          if(gst == false && shipping == true){
           return (TotalAmount + shipAmount) - gstAmount;
          }
          if(gst == false && shipping == false){
           return taxableAmount;
          }
       
        }else{
           if(gst == true && shipping == true){
             return creditAmount;
            }
           if(gst == false && shipping == true){
             if((taxableAmount + shipAmount) > creditAmount){
               return creditAmount;
             }else{
               return taxableAmount + shipping;
             }
            }
           if(gst == true && shipping == false){
             if((taxableAmount + gstAmount) > creditAmount){
               return creditAmount;
             }else{
               return taxableAmount + gstAmount;
             }
            }
           if(gst == false && shipping == false){
             if(taxableAmount > creditAmount){
               return creditAmount;
             }else{
               return taxableAmount;
             }
            }       
         }

      }
 
 const reapplycredit = async () =>{
   const formdata = new FormData();
   formdata.append("shipping_charge",shippingCharges.price);
   const response = await appliedCredit(formdata);
   cartInfo.cartRefetch();
 }

  const [savecartper ,setsavecartper] = useState(false)
  const calluserper = async () =>{
    let url = `${process.env.REACT_APP_API_URL}useraccount/permisson-check`;
    const Tokendata = tokenvalue.access
    try {
      const response = await axios.get(url, {headers: {
        Authorization: `Bearer ${Tokendata}`
      }});
      setsavecartper(response.data.saved_cart_process)

    } catch (error) {
      console.error("Invalid JSON in localStorage:", error);
    }
    
    
  }
 useEffect(()=>{
   calluserper();
  shippingidremove();
},[]);




  useEffect(() => {
    if(creditLoading == false){
    const product_list = cartInfo.cartData.product_deatils;
    if(cartInfo.cartData?.credit_amount){
      setAppliedCreditAmount(cartInfo.cartData?.credit_amount);
    }else{
      setAppliedCreditAmount(0)
    }
    settableData(product_list);
    setclient_Discount_Status(product_list.some(item => item.cli_discount > 0));  // client Discount 
    setOutOfStock(product_list.some((item) => item.stock == 0));  // any Item is Out of Stock
    settotalqty(product_list.reduce((acc, product) => acc + 1 * product.quantity, 0));  // Total Item QTY
    settotalmrp(product_list.reduce((acc, product) => acc + product.price_excl_tax * product.quantity, 0));  // total MRP Price
    setgst_total(product_list.reduce((total, item) => total + item.gst_tax_amount * item.quantity, 0));  // total GST
    settaxable_total(product_list.reduce((total, item) => total + item.base_price * item.quantity, 0));  // total Taxable Amount
    if(creditData.expired === false){
       settotalCreditAmount(creditData.amount);
       setcredit_minus_amount(creditData.minus_amount)
       setcreditShipping(creditData.shipping_value)
       setcreditGst(creditData.GST)
       const creditvalue = creditUsed(
              shippingCharges.price,
              (product_list.reduce((total, item) => total + item.gst_tax_amount * item.quantity, 0) + product_list.reduce((total, item) => total + item.base_price * item.quantity, 0)),
              product_list.reduce((total, item) => total + item.gst_tax_amount * item.quantity, 0),
              product_list.reduce((total, item) => total + item.base_price * item.quantity, 0),
              creditData.amount,
              creditData.GST,
              creditData.shipping_value
       );
       setAllowCredit(creditvalue.toFixed(0));
       if (
            cartInfo.cartData?.credit_amount && 
            Math.abs(creditvalue.toFixed(0) - cartInfo.cartData?.credit_amount) > 2
          ) {
            reapplycredit();
          }
    }     

    }
  }, [cartInfo,creditData,creditLoading])

  return (
    <>
      <Header />

      <div className='breadcrumb-main margincart'></div>
      <section className="section-big-py-space b-g-light">
        <div className="container-fluid d-flex justify-content-center">
          <div className="row justify-content-center definewidth align-items-start">
            <div className="col-lg-8" style={{ paddingBottom: "4px" }}>

              <Table
                cartInfo={cartInfo}
                tableData={tableData}
                reapplycredit={reapplycredit}
                status={{ client_Discount_Status, setshowbtn }}
                count={{ taxable_total, gst_total, totalmrp, totalqty }}
              />

              {totalqty > 0 ? (
                <CreditSection
                  tableData={{
                    gst:creditGst,
                    shipping:creditShipping,
                    total:totalCreditAmount,
                    mamount:credit_minus_amount,
                    AllowCredit,
                    AppliedCreditAmount,
                    shipAmount:shippingCharges.price
                  }}
                  cartInfo={cartInfo}
                  setshowbtn={setshowbtn}
                  reapplycredit={reapplycredit}
                />)
                : ''}
            </div>

            <div className=" col-lg-4 mt-lg-0 mt-md-0 mt-sm-3 mt-xs-3 makestk">
              <Address address={address} onAddressChange={onAddressChange} />
              <Creditsummary
                cartInfo={cartInfo}
                address={address}
                shippingCharges={shippingCharges}
                status={{ client_Discount_Status, setshowbtn, showbtn,outofstock,isTableEmpty:tableData.length,savecartper }}
                count={{ taxable_total, gst_total, totalmrp, totalqty,AppliedCreditAmount }}

              />

            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Credit